import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminChangelogEntries = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/changelog_entries/index.vue')
    createVueApp(IndexPage, { props })
  },
  new: async(props) => {
    const { default: FormPage } = await import('@/vue_widgets/admin/changelog_entries/form.vue')
    createVueApp(FormPage, { props })
  },
  edit: async(props) => {
    const { default: FormPage } = await import('@/vue_widgets/admin/changelog_entries/form.vue')
    createVueApp(FormPage, { props })
  }
}
